<wj-tab-panel class="full-size-tab" [selectedIndex]="0" [isAnimated]="true" style="height: 100%"
              appWjTabStatePersist tabStateKey="dashboard-volatility">
    <wj-tab>
        <a>Chart</a>
        <div class="fullsize-vbox" style="gap: 5px;">
            <wj-flex-chart #volatilityChart [chartType]="Wijmo.ChartType.Scatter" [bindingX]="'x'"
                           header="Control Accounts: distribution as function of LL Frequency vs LL Margin"
                           style="resize: both; overflow: hidden; height: 700px; width: 95%"
            >
                <wj-flex-chart-axis #axisX wjProperty="axisX" [min]="0" title="LL Frequency" format="p1"
                                    [axisLine]="true" [majorGrid]="false" [origin]="0">
                </wj-flex-chart-axis>

                <wj-flex-chart-axis #axisY wjProperty="axisY" title="LL Margin" format="p1"
                                    [axisLine]="true" [majorGrid]="false">
                </wj-flex-chart-axis>

                <wj-flex-chart-series #volatilityChartSeries [binding]="'y'" [tooltipContent]="tooltipContent"
                                      [itemFormatter]="itemFormatter">
                </wj-flex-chart-series>

                <wj-flex-chart-series #separatorSeries [chartType]="Wijmo.ChartType.Line" [binding]="'y'" [style]="quadrantDivisorStroke">
                </wj-flex-chart-series>

                <wj-flex-chart-legend [position]="Wijmo.Position.None"></wj-flex-chart-legend>

                <wj-flex-chart-annotation-layer control="al">
                    <wj-flex-chart-annotation-text  text="Risk remunerative accounts"
                                                    [attachment]="Wijmo.AnnotationAttachment.Relative"
                                                    [position]="Wijmo.AnnotationPosition.Left"
                                                    [point]="{x:0.85, y: 0.02 }"
                                                    [style]="{ 'fill': '#bbbbbb', 'font-size': '26px' }"></wj-flex-chart-annotation-text>
                    <wj-flex-chart-annotation-text  text="Focus accounts"
                                                    [attachment]="Wijmo.AnnotationAttachment.Relative"
                                                    [position]="Wijmo.AnnotationPosition.Left"
                                                    [point]="{x:1.0, y:0.05}"
                                                    [style]="{ 'fill': '#bbbbbb', 'font-size': '26px', 'writing-mode': 'vertical-lr' }">
                    </wj-flex-chart-annotation-text>
                </wj-flex-chart-annotation-layer>

            </wj-flex-chart>
        </div>
    </wj-tab>
    <wj-tab>
        <a>Accounts</a>
        <div>
            <div class="fullsize-vbox" style="gap: 5px;">
                <div class="layout-hbox" style="gap: 5px">
                    <label>Threshold:</label>
                    <wj-input-number format="p1" [(ngModel)]="threshold"></wj-input-number>
                </div>
                <wj-flex-grid #grid (visibilityChange)="onGridInitialized(grid, gridFilter)" appVisibilityObserver
                              [showSelectedHeaders]="Wijmo.HeadersVisibility.All"
                              [showMarquee]="true" width="100%" style="height: 100%"
                              [allowResizing]="Wijmo.AllowResizing.Both" [autoRowHeights]="false" [quickAutoSize]="false"
                              [headersVisibility]="Wijmo.HeadersVisibility.All" [selectionMode]="Wijmo.SelectionMode.MultiRange" [isReadOnly]="false"
                              [autoGenerateColumns]="false"
                              [cloneFrozenCells]="true"
                              [allowSorting]="Wijmo.AllowSorting.MultiColumn"
                              [allowPinning]="Wijmo.AllowPinning.None"
                >
                    <wj-flex-grid-filter #gridFilter [defaultFilterMode]="Wijmo.FilterMode.SingleFilter"></wj-flex-grid-filter>
                    <div #gridMenuBtn class="menu-host-no-dropdown-button"></div>
                </wj-flex-grid>

                <div class="layout-hbox" style="align-items: center; justify-content: flex-end; grid-gap: 10px;">
                    <wj-flex-grid-search #gridSearch style="flex-grow: 1"
                                         placeholder="Search key(s)"
                                         [grid]="grid">
                    </wj-flex-grid-search>
                </div>
            </div>
        </div>
    </wj-tab>
</wj-tab-panel>
